module.exports = __webpack_public_path__ + "static/Staffing1-2709782543c42753087f79db5086d7e5.jpg";